// extracted by mini-css-extract-plugin
export default {"container":"OutstreamVideoAd-module__container___xzymZ"};